/**
 * Typed error for share-intent play failures. The `kind` enables
 * UX-tier code to map to user-facing toast messages without parsing the
 * message string.
 *
 * Kinds in use:
 *   - 'forge-not-ready'   : forge service didn't initialize within timeout
 *   - 'task-not-found'    : GET_TASK_BY_ID failed or returned null
 *   - 'task-has-no-tags'  : task exists but has no associated tags
 *   - 'tags-unavailable'  : GET_BASE_TAGS_BY_IDS failed or returned empty
 *   - 'permission-denied' : (future) user lacks access to the resource
 *   - 'facility-mismatch' : (future) the resource doesn't belong to URL facility
 *   - 'facility-access-denied' : user has no access to the URL's facility
 */
export class ShareIntentError extends Error {
  /**
   * @param {string} message
   * @param {string} kind
   */
  constructor(message, kind) {
    super(message);
    this.name = 'ShareIntentError';
    this.kind = kind;
  }
}
